var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExport({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 6.491v9.51a1 1 0 11-2 0V6.49L9.784 7.697a1.051 1.051 0 01-1.705-.335 1.03 1.03 0 01.227-1.13l2.955-2.929a1.051 1.051 0 011.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 01-1.478 0L13 6.49v.001zm-4 2.51v2H7c-.002 0 0 7.99 0 7.99 0 .004 9.994.01 9.994.01.003 0 .006-7.992.006-7.992 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.01v7.981c0 1.11-.897 2.01-2.006 2.01H7.006A2.009 2.009 0 015 18.99v-7.98A2 2 0 017 9h2z"
  })));
}

export default SvgExport;